// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"df746003","228":"f1d21b77","453":"cee5cfbd"}[chunkId] + ".chunk.js";
};